import { render, staticRenderFns } from "./LatestOrders.vue?vue&type=template&id=4fd54657&scoped=true&"
import script from "./LatestOrders.vue?vue&type=script&lang=js&"
export * from "./LatestOrders.vue?vue&type=script&lang=js&"
import style0 from "./LatestOrders.vue?vue&type=style&index=0&id=4fd54657&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd54657",
  null
  
)

export default component.exports